export default __webpack_public_path__ + "static/media/customization.0a936f6c.svg";